<template>
    <div> 
        <div class="container" style="margin-top:-15px;"> 
            
            <el-table style="margin-top:-10px;" :data="tableData" size="small" class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                 
                <el-table-column prop="id" width="80" align="center" label="编号"></el-table-column>
                <el-table-column prop="woType" width="80" align="center" label="分类">
                    <template slot-scope="scope">
                        {{scope.row.woType==1?'订单问题':scope.row.woType==2?'佣金问题':scope.row.woType==3?'产品问题':scope.row.woType==4?'系统 bug':scope.row.woType==5?'投诉建议':''}}
                    </template>
                </el-table-column> 
                <el-table-column prop="title" min-width="100" align="left" label="标题">
                    <template slot-scope="scope">
                        <el-tooltip  class="item" effect="dark" :content="scope.row.title" placement="bottom" open-delay="100" hide-after="1500">
                                <span style="font-size:12px;width:100%;overflow:hidden;display: inline-block;
    height: 20px;line-height:29px;">{{scope.row.title}}</span>
                            </el-tooltip>   
                    </template>
                </el-table-column> 
                 <el-table-column prop="linkNo" width="150" align="left" label="关联信息">
                    <template slot-scope="scope">
                        <span style="font-size:12px">{{scope.row.linkNo}}</span>
                    </template> 
                </el-table-column> 
                <el-table-column prop="title" min-width="150" align="left" label="内容">
                    <template slot-scope="scope">
                       <el-tooltip  class="item" effect="dark" :content="scope.row.content" placement="bottom" open-delay="100" hide-after="1500">
                                <span style="font-size:12px;width:100%;overflow:hidden;display: inline-block;
    height: 20px;line-height:29px;">{{scope.row.content}}</span>
                            </el-tooltip>   
                    </template> 
                </el-table-column>
                <el-table-column prop="woStatus" width="60" align="center" label="状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.woStatus==2?'success':scope.row.woStatus==1?'primary':'info'">
                            {{scope.row.woStatus==0?'已提交':scope.row.woStatus==1?'处理中':scope.row.woStatus==2?'已回复':scope.row.woStatus==3?'待回复':scope.row.woStatus==4?'已关闭':''}}
                        </el-tag>
                    </template>
                </el-table-column>  
                <el-table-column prop="createTime" width="170" align="center"  label="创建时间"> </el-table-column>    
                <el-table-column label="操作" width="110" align="center"  fixed="right">
                    <template slot-scope="scope" >
                        <el-button-group>  
                            <el-tooltip  class="item" effect="dark" content="处理记录" placement="bottom" open-delay="10" hide-after="1500">
                                <el-button icon="el-icon-lx-edit" size="small" type="error"  @click="handleEdit(scope.$index, scope.row)" ></el-button>
                            </el-tooltip>           
                        </el-button-group> 
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <!-- 新建绑定弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="创建工单" :modal-append-to-body='false' :visible.sync="addVisible"  center="true"   >
            <el-form ref="form1" :model="form1" label-width="50px">
                <el-form-item label="分类" >
                    <el-radio-group v-model.trim="form1.woType" >
                        <el-radio-button label="1">订单问题</el-radio-button> 
                        <el-radio-button label="2">佣金问题</el-radio-button>
                        <el-radio-button label="3">产品问题</el-radio-button>
                        <el-radio-button label="4">系统 bug </el-radio-button>  
                        <el-radio-button label="5">投诉建议</el-radio-button>
                    </el-radio-group> 
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model.trim="form1.title" placeholder="概述问题，不超过20个字"></el-input>
                </el-form-item> 
                <el-form-item label="关联">
                    <el-input v-model.trim="form1.linkNo" placeholder="输入单号或商品编码"></el-input>
                </el-form-item> 
                <el-form-item label="内容">
                    <el-input type="textarea" placeholder="描述问题，不超过100个字" :rows="5" v-model.trim="form1.content" ></el-input>
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog :close-on-click-modal="false" title="处理记录" :modal-append-to-body='false' :visible.sync="editVisible"  center="true" top="50px" >
            <el-form ref="form" :model="form" label-width="80px">
                <el-tag style="display:inline-block;width:100%;border-radius:0;border-left:5px solid #409EFF;" type="info">售后问题</el-tag>
                <p style="font-size:12px;border:1px solid #ddd;padding:5px 10px;line-height:20px;">
                    标题：{{form.title}}<br/>
                    类型：{{form.woType==1?'订单问题':form.woType==2?'佣金问题':form.woType==3?'产品问题':form.woType==4?'系统 bug':form.woType==5?'投诉建议':''}}
                    <br/>
                    关联：{{form.linkNo}}<br/>
                    内容：{{form.content}}<br/> 
                </p> 
                <el-tag style="display:inline-block;width:100%;border-radius:0;border-left:5px solid #409EFF;" type="info">处理记录</el-tag>
                <p style="font-size:12px;border:1px solid #ddd;padding:5px 10px;line-height:20px;">
                    <span v-for="item in replyList">
                        <span v-if="item.replyType==1" style="display:inline-block;width:100%">
                            <span style="font-weight:700;display:inline-block;height:30px;line-height:30px;">
                                <img :src="stationLogo" style="width:30px;height:30px;line-height:30px;border-radius:50%;vertical-align:middle;margin-top:-3px;margin-right:5px;">
                                {{stationName}}
                            </span>
                            <span style="float:right;height:30px;line-height:30px;">
                                {{item.createTime}}
                            </span> 
                        </span>
                        <span v-if="item.replyType==1" style="display:inline-block;width:88%;padding:0 10px 0 40px;margin-top:5px;">  {{item.reply}} </span> 
                        <span v-if="item.replyType==2" style="display:inline-block;width:100%">
                            <span style="font-weight:700;display:inline-block;height:30px;line-height:30px;">
                                <img :src="avatar" style="width:30px;height:30px;line-height:30px;border-radius:50%;vertical-align:middle;margin-top:-3px;margin-right:5px;">
                                {{username}}
                            </span>
                            <span style="float:right;height:30px;line-height:30px;">
                                {{item.createTime}}
                            </span> 
                        </span>
                        <span v-if="item.replyType==2" style="display:inline-block;width:88%;padding:0 10px 0 40px;margin-top:5px;">   {{item.reply}}  </span>
                    </span>
                </p>  
            </el-form> 
        </el-dialog>
    </div>
</template>

<script>
import {fetchData2 as fetchData,saveForm,handDelete,replyForm,getReplayList} from '../../api/woHandle';
import Bus from "../common/woNavBus";
export default {

    data() {
        return { 
            replyList:[],
            stationLogo:'',
            stationName:'',
            avatar:'',
            username:'',
            mid:'',
            secret:'',
            stationId:'',
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible:false,
            pageTotal: 0,
            form: {  
                replyType:'2',
            },
            form1: {  
                woType:1,
            },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    }, 
    //页面加载方法
    mounted() {
        this.mid = localStorage.getItem('ms_mid');
        this.secret = localStorage.getItem('ms_secret');
        this.stationId = localStorage.getItem('ms_stationId'); 
        this.getData();  
        Bus.$on("getData", () => {
	      //a传来的参数  
	      this.getData() // 可以做其他操作
	    });
        Bus.$on("addBind2", () => {
	      //a传来的参数  
	      this.addBind2() // 可以做其他操作
	    });
    },
    methods: { 
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        //刷新
        refresh(){
            history.go(0); 
        },
        //重置
        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'gname', ''); 
            this.getData();
            //清空下拉框   
        }, 
        //查询 
        getData(){
            const query = this.query;
            // 获取列表数据  
            query.mid = this.mid;
            query.stationId = this.stationId;  
            query.woStatus = '4'; 
            fetchData(query).then(res => {   
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
            });
        },
        // 删除
        handDelete(index, row) {  
            this.form.gid=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){
                        this.addVisible = false;
                        this.$message.success('删除成功'); 
                        this.query.pageIndex = this.query.pageIndex-1;
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("已有代理绑定该等级，请更换绑定后再删除"); 
                    } 
                });
            }) 
        },
        // 多选操作
       
        // 新增绑定
        addBind2() {
            this.addVisible = true;
        },
        //保存新增
        saveForm() {  
            this.form1.mid = this.mid;
            this.form1.stationId = this.stationId;   
            if( !this.form1.title){
                this.$message.error("请填写标题");
                return;
            }
            if( this.form1.title && this.form1.title.length>20){
                this.$message.error("标题不超过20个字");
                return;
            }
            if( !this.form1.content){
                this.$message.error("请填写内容");
                return;
            }
            if( this.form1.content && this.form1.content.length>100){
                this.$message.error("内容不超过100个字");
                return;
            } 
            this.addVisible = false;
            saveForm(this.form1).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                    Bus.$emit("getData");
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.stationName = localStorage.getItem('ms_stationName');
            this.stationLogo = localStorage.getItem('ms_stationLogo');
            this.avatar = localStorage.getItem('ms_avatar');
            this.username = localStorage.getItem('ms_username');  
            this.form = row;
            this.form.stationId = this.stationId;
            getReplayList(this.form).then(res => {
                if(res.code=='200'){ 
                    this.replyList = res.data; 
                    this.editVisible = true;
                }else{
                    this.$message.error(res.message); 
                }
            }); 
        },
        // 保存编辑
        saveEdit() {   
            if( !this.form.reply){
                this.$message.error("请填写回复");
                return;
            }
            if( this.form.reply && this.form.reply.length>50){
                this.$message.error("回复不超过50个字");
                return;
            }  
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            this.form.replyType = '2';
            this.editVisible = false;
            replyForm(this.form).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData(); 
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>
<style>

</style>

<style>

@media screen and (max-width:999px){ 
    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 10px;
    }
    .el-dialog,.el-dialog--center{
        width:315px;
    }
     .el-dialog__header {
        padding: 10px 10px 0px;
    }
    .btnCss{
       height:40px;
       margin-left:10px; 
    }
    .handle-del {
        float:left; 
        margin-top:10px;
        margin-left:10px; 
        margin-right:10px;  
    }
} 
@media screen and (min-width:999px){ 
    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 25px 25px 30px;
    }
     .el-dialog__header {
        padding: 20px 20px 0px;
    }
    
    .el-dialog,.el-dialog--center{
        width:560px;
    }
    .btnCss{
        
        display:inline-block;
    }
    .handle-del {
        float:right; 
    }
} 

 

.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
} 
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
